import PropTypes from 'prop-types';
import * as S from './Grid.styles.tsx';
import { buildGridArea } from './GridUtils.inner.tsx';

const Grid = ({ children, xxs, xs, s, m, l }) => (
  <S.Grid
    data-testid='grid-component'
    xxs={xxs && buildGridArea(xxs, 'xxs')}
    xs={xs && buildGridArea(xs, 'xs')}
    s={s && buildGridArea(s, 's')}
    m={m && buildGridArea(m, 'm')}
    l={l && buildGridArea(l, 'l')}
  >
    {children}
  </S.Grid>
);

const GridArea = ({ children, name }) => (
  <S.Area data-testid='grid-area' name={name}>
    {children}
  </S.Area>
);

Grid.Area = GridArea;

Grid.propTypes = {
  xxs: PropTypes.arrayOf(PropTypes.array),
  xs: PropTypes.arrayOf(PropTypes.array),
  s: PropTypes.arrayOf(PropTypes.array),
  m: PropTypes.arrayOf(PropTypes.array),
  l: PropTypes.arrayOf(PropTypes.array),
};

export default Grid;
